






























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AjaxHelper } from '@/AjaxHelper';
import { IMinecraftAccount, IStudentListItem, IValidations } from '@/interfaces';
import { StudentListItemValidator } from '@/validators';
import { getAxiosErrorMessage } from '@/utils';

import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import Btn from '@/components/Btn.vue';

@Component({
  name: 'student-form',
  components: { Field, TextField, Btn }
})
export default class StudentFormComponent extends Vue {
  @Prop({ required: true }) public initial!: IStudentListItem;
  @Prop() public saveCallback!: (student: IStudentListItem) => Promise<void>;
  @Prop() public cancelStudentEdit!: () => void;

  public saving = false;
  public student: IStudentListItem | null = null;
  public studentValidations: IValidations<IStudentListItem> | null = null;

  public studentValidator: StudentListItemValidator = new StudentListItemValidator();

  public mounted() {
    this.student = JSON.parse(JSON.stringify(this.initial));
  }

  public async saveStudent() {
    if (this.student !== null) {
      const validations = this.studentValidator.isValid(this.student);

      if (validations !== true) {
        this.studentValidations = validations;
        this.$alert.warning('Student Validation Warnings', 'Please check the form for details');
        return;
      }

      try {
        this.saving = true;
        console.log(this.student);

        if (this.student.minecraftAccountId.length === 0) {
          const data = await AjaxHelper.get<IMinecraftAccount | string>(`/minecraftaccountmanagement/${encodeURIComponent(this.student.minecraftAccountUserName)}`);
          if (typeof data === 'string' && data.length === 0) {
            this.studentValidations = { minecraftAccountUserName: ['Minecraft Account does not exist please review'] };
            console.log('Stuff');
            return;
          }

          this.student.minecraftAccountId = (data as IMinecraftAccount).id;
        }

        if (this.saveCallback !== undefined) {
          await this.saveCallback(this.student);
        }
      } catch (ex) {
        console.log({ ex });
        const message = getAxiosErrorMessage(ex);
        if (message !== null) {
          this.$alert.danger(message);
        }
      } finally {
        this.saving = false;
      }
    }
  }

  public getStudentValidation(key: keyof IStudentListItem) {
    return this.studentValidations !== null && this.studentValidations[key] !== undefined ?
      this.studentValidations[key] : [];
  }

  @Watch('student', { immediate: true, deep: true })
  public onNewStudentChange(newStudent: IStudentListItem | null) {
    if (newStudent !== null && this.studentValidations !== null) {
      const validations = this.studentValidator.isValid(newStudent);
      this.studentValidations = validations !== true ? validations : null;
    } else if (newStudent === null && this.studentValidations !== null) {
      this.studentValidations = null;
    }
  }

  @Watch('student.minecraftAccountUserName')
  public onMinecraftAccountUserNameChange(newItem: string | undefined, oldItem: string | undefined) {
    if (this.student !== null && oldItem !== undefined) {
      this.student.minecraftAccountId = '';
    }
  }
}
